import { IModalContext } from './interfaces';
export const initState: IModalContext = {
  open: false,
  content: 'BASIC',
};
